var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-table", {
        ref: "table",
        attrs: {
          title: "규제 DB 업로드 목록",
          columns: _vm.grid.columns,
          data: _vm.grid.data,
        },
        on: { linkClick: _vm.openPop },
        scopedSlots: _vm._u([
          {
            key: "table-button",
            fn: function () {
              return [
                _c(
                  "q-btn-group",
                  { attrs: { outline: "" } },
                  [
                    _vm.editable
                      ? _c("c-btn", {
                          attrs: { label: "등록", icon: "add" },
                          on: {
                            btnClicked: function ($event) {
                              return _vm.openPop()
                            },
                          },
                        })
                      : _vm._e(),
                    _c("c-btn", {
                      attrs: { label: "검색", icon: "search" },
                      on: { btnClicked: _vm.getList },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }